import React from "react";
import { useNavigate } from "react-router-dom";

export default function CheckoutCancelled() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-fc-navy text-white flex items-center justify-center px-6" data-testid="checkout-cancelled-page">
      <div className="max-w-lg w-full bg-[#060A24] border border-white/10 p-10 text-center">
        <div className="fc-overline mb-3">CHECKOUT CANCELLED</div>
        <h1 className="fc-h-section text-2xl mb-3">Come back when you're ready.</h1>
        <p className="text-white/70 mb-8">No charge was made. Your spot is still here.</p>
        <button onClick={() => navigate("/pricing")} className="btn-fc-red w-full justify-center" data-testid="back-to-pricing">
          Back to Pricing
        </button>
      </div>
    </div>
  );
}
